// src/pages/tour-packages/hooks/useCreateTourPackage.ts

import { useNavigate } from "react-router-dom";

import {
  useCreateTour,
  type CreateTourWithDetailsPayload,
  type TourHeader,
} from "@/api/features/tours";

export type UseCreateTourPackageOptions = {
  /** Called after successful creation (after navigation). */
  onSuccess?: (tour: TourHeader, payload: CreateTourWithDetailsPayload) => void;

  /** Called when creation fails. */
  onError?: (error: Error, payload: CreateTourWithDetailsPayload) => void;
};

/**
 * useCreateTourPackage
 * --------------------
 * Wrapper around useCreateTour that:
 * - calls POST /api/v1/tours
 * - on success, navigates back to /tour/tour-packages
 * - optionally calls onSuccess/onError callbacks
 */
export function useCreateTourPackage(options?: UseCreateTourPackageOptions) {
  const navigate = useNavigate();

  return useCreateTour({
    onSuccess: (tour, payload) => {
      navigate("/tour/tour-packages");
      options?.onSuccess?.(tour, payload);
    },
    onError: (error, payload) => {
      options?.onError?.(error, payload);
    },
  });
}